import { useOption } from "#/store/options/tradePanel/option";
import { useOptionLimitPrice } from "#/store/options/tradePanel/optionLimitPrice";
import { useOptionSize } from "#/store/options/tradePanel/optionSize";
import { type EstimatedExecPriceProps } from "#/types/fees";
import {
  CalculatedExecPrice,
  calculateEstimatedExecutionPrice,
  execPriceDefaultValues,
} from "#/utils/estimatedExecPrice.utils";

export const useCalcOptionsMarketExecPrice = ({
  type,
  kind,
}: EstimatedExecPriceProps): CalculatedExecPrice => {
  const { option } = useOption();
  const { optionSizeNum } = useOptionSize();
  const { optionLimitPriceNum } = useOptionLimitPrice();
  const isMissingDetails = !optionSizeNum || !optionLimitPriceNum || !option;

  if (type !== "market" || kind !== "options" || isMissingDetails)
    return execPriceDefaultValues;

  return calculateEstimatedExecutionPrice(optionSizeNum, option);
};
